import { useEffect, useState } from "react";
import { Outlet, useSearchParams } from "react-router-dom";
import { LoadingOverlay, useLineMgmContext } from "@/apps/@components";
import { api } from "@/apps/@utils";

export default function VisitorGuard() {
    const [searchParams] = useSearchParams();
    const { customData } = useLineMgmContext();
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        (async () => {
            try {
                const result = (await api.post("/logs/register", {
                    from: customData.from ?? searchParams.get("from"),
                })).data;
                localStorage.setItem("visitor_id", result.visitor_id);
            }
            catch (error) {
                console.error(error);
            }
            finally {
                setIsMounted(true);
            }
        })();
    }, []);
    
    return isMounted ? <Outlet /> : <LoadingOverlay visible={true} />
}

